import { Box, Stack, Toolbar } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import { FC } from 'react';
import { createUseStyles } from 'react-jss';
import BrandLogo from '../brand-logo';
import UserMenu from '../user-menu';
import useApp from '@/hooks/use-app.hook';
import { getBreakpoint } from '@/theme';

const useStyles = createUseStyles<string>({
  header: {
    width: '100%',
    backgroundColor: 'inherit',
    borderBottom: '1px solid #EFEFEF',
    boxShadow: 'none',
  },
  headerInner: {
    padding: '0px 24px',
    width: '100%',
    boxSizing: 'border-box',
  },
  logoLink: {
    display: 'block',
    '&:hover': {
      opacity: 1,
    },
  },
  [getBreakpoint('md')]: {
    headerInner: {
      padding: '0px 16px',
    },
  },
});

const AppHeader: FC = () => {
  const styles = useStyles();
  const { signedIn, user, branding } = useApp();

  return (
    <AppBar className={styles.header}>
      <Toolbar className={styles.headerInner}>
        <Box minWidth={250}>
          <a href="/" className={styles.logoLink}>
            <BrandLogo />
          </a>
        </Box>
        <Stack direction="row" flexGrow={1} justifyContent="flex-end">
          {signedIn && <UserMenu user={user!} branding={branding} />}
        </Stack>
      </Toolbar>
    </AppBar>
  );
};

export default AppHeader;
